// ============================================================================
// Form Config: Roles
// Key: roles
// Generated file. Do not edit manually.
// ============================================================================

// #region Imports
import type { FormSection } from '@/shared/forms/GenericForm'
import { enumFormOptions } from '../../entity-config-runtime/entity-form-config'
import { ApplicationScope, EntityScope } from '../api/backstage.schemas'
// #endregion

// #region Create Form
export const rolesCreateFormConfig: FormSection[] = [
	{
		title: 'forms_roles_create_section_main',
		fields: [
			{
				name: 'name',
				label: 'forms_roles_create_name',
				type: 'text' as const,
				initialValue: '',
			},
			{
				name: 'entityScope',
				label: 'forms_roles_create_entity_scope',
				type: 'select' as const,
				options: enumFormOptions(EntityScope, 'EntityScope'),
				initialValue: '',
			},
			{
				name: 'applicationScope',
				label: 'forms_roles_create_application_scope',
				type: 'select' as const,
				options: enumFormOptions(ApplicationScope, 'ApplicationScope'),
				initialValue: '',
			},
			{
				name: 'isDefault',
				label: 'forms_roles_create_is_default',
				type: 'checkbox' as const,
				initialValue: false,
			},
		],
	},
]
// #endregion

// #region Edit Form
export const rolesEditFormConfig: FormSection[] = [
	{
		title: 'forms_roles_edit_section_main',
		fields: [
			{
				name: 'name',
				label: 'forms_roles_edit_name',
				type: 'text' as const,
				initialValue: '',
			},
			{
				name: 'entityScope',
				label: 'forms_roles_edit_entity_scope',
				type: 'select' as const,
				options: enumFormOptions(EntityScope, 'EntityScope'),
				initialValue: '',
			},
			{
				name: 'applicationScope',
				label: 'forms_roles_edit_application_scope',
				type: 'select' as const,
				options: enumFormOptions(ApplicationScope, 'ApplicationScope'),
				initialValue: '',
			},
			{
				name: 'isDefault',
				label: 'forms_roles_edit_is_default',
				type: 'checkbox' as const,
				initialValue: false,
			},
		],
	},
]
// #endregion

// #region Forms Config Export
export const rolesFormsConfig = {
	create: rolesCreateFormConfig,
	edit: rolesEditFormConfig,
} as const
// #endregion
